<template>
    <div class="page">
        <ion-grid fixed v-if="profile">
        <ion-row class="row-divider"></ion-row>
            <ion-row class="rectangle">
                <ion-col>
                    <ion-row align-items-stretch>
                        <ion-col class="col-padding">
                            <ion-label class="section-head">Profile</ion-label>
                        </ion-col>
                    </ion-row>
                    <ion-row align-items-stretch>
                        <ion-col size="12" size-md="4" class="col-padding">
                            <ion-label class="section-item" position="stacked">Email</ion-label>
                            <div class="section-desc margin-top-10">{{profile.email}}</div>
                        </ion-col>
                        <ion-col size="12" size-md="4" class="col-padding">
                            <ion-label class="section-item" position="stacked">Mobile</ion-label>
                            <div class="section-desc margin-top-10">{{profile.mobile}}</div>
                        </ion-col>
                        <ion-col size="12" size-md="4" class="col-padding">
                            <ion-label class="section-item" position="stacked">First Name</ion-label>
                            <div class="section-desc margin-top-10">{{profile.firstName}}</div>
                        </ion-col>
                        <ion-col size="12" size-md="4" class="col-padding">
                            <ion-label class="section-item" position="stacked">Last Name</ion-label>
                            <div class="section-desc margin-top-10">{{profile.lastName}}</div>
                        </ion-col>
                        <ion-col size="12" size-md="4" class="col-padding">
                            <ion-label class="section-item" position="stacked">Gender</ion-label>
                            <div class="section-desc margin-top-10">{{profile.gender.description}}</div>
                        </ion-col>
                        <ion-col size="12" size-md="4" class="col-padding">
                            <ion-label class="section-item" position="stacked">Date of Birth</ion-label>
                            <!-- <div class="section-desc margin-top-10">{{profile.dob | dateFormat('DD MMM, YYYY')}}</div> -->
                            <div class="section-desc margin-top-10">{{changeDateFormatWithoutTime(profile.dob)}}</div>
                        </ion-col>
                    </ion-row>
                    <hr />
                    <ion-row align-items-stretch>
                        <ion-col class="col-padding">
                            <ion-label class="section-head">Address</ion-label>
                        </ion-col>
                    </ion-row>
                    <ion-row align-items-stretch>
                        <ion-col size="12" size-md="4" class="col-nopadding">
                            <ion-label class="section-item" position="stacked">Building Name</ion-label>
                            <div class="section-desc margin-top-10">{{profile.address.line1}}</div>
                        </ion-col>
                        <ion-col size="12" size-md="4" class="col-nopadding">
                            <ion-label class="section-item" position="stacked">Street Address</ion-label>
                            <div class="section-desc margin-top-10">{{profile.address.line2}}</div>
                        </ion-col>
                        <ion-col size="12" size-md="4" class="col-nopadding">
                            <ion-label class="section-item" position="stacked">Area Name</ion-label>
                            <div class="section-desc margin-top-10">{{profile.address.line3}}</div>
                        </ion-col>
                        <ion-col size="12" size-md="4" class="col-nopadding">
                            <ion-label class="section-item" position="stacked">City</ion-label>
                            <div class="section-desc margin-top-10">{{profile.address.city}}</div>
                        </ion-col>
                        <ion-col size="12" size-md="4" class="col-nopadding">
                            <ion-label class="section-item" position="stacked">State</ion-label>
                            <div class="section-desc margin-top-10">{{profile.address.state.name}}</div>
                        </ion-col>
                        <ion-col size="12" size-md="4" class="col-nopadding">
                            <ion-label class="section-item" position="stacked">Pincode</ion-label>
                            <div class="section-desc margin-top-10">{{profile.address.zipcode}}</div>
                        </ion-col>
                    </ion-row>
                </ion-col>
            </ion-row>
        </ion-grid>
        <div class="spinner">
            <ion-spinner v-if="loaderTab"></ion-spinner>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonGrid, IonRow, IonCol, IonLabel, IonSpinner } from "@ionic/vue";
import { ProfilerService } from "../../service/profile/profiler.service";
import { User } from "@/entity/authentication/user";
import moment from "moment";

export default defineComponent ({
    name: 'customerProfile',
    components: { IonGrid, IonRow, IonCol, IonLabel, IonSpinner },
    data() {
        return {
            loaderTab: true,
            profile: null,
        }
    },
    async mounted() {
        this.profile = await new ProfilerService().profileOfCustomer(
            new User(this.$route.params.profileId)
        );
        this.loaderTab = false;
    },
    methods: {
        changeDateFormatWithoutTime(dateValue) {
            if(dateValue != null) {
                return moment(dateValue).format('DD/MMM/YYYY')
            }
        },
    }
})
</script>